export const errorListener: Array<(error: any) => void> = []
